import cx from "classnames";
import {
  type KeyboardEvent,
  type ReactNode,
  type Ref,
  forwardRef,
} from "react";

import { Box, Flex } from "metabase/ui";

import S from "./ParameterValueWidget.module.css";

export const ParameterValueWidgetTrigger = forwardRef(
  ParameterValueWidgetTriggerInner,
);

function ParameterValueWidgetTriggerInner(
  {
    children,
    hasValue,
    ariaLabel,
    className,
    mimicMantine = false,
    hasPopover = false,
  }: {
    children: ReactNode;
    hasValue: boolean;
    ariaLabel?: string;
    className?: string;
    mimicMantine?: boolean;
    hasPopover?: boolean;
  },
  ref: Ref<HTMLDivElement>,
) {
  const attributes = hasPopover
    ? {
        component: "div" as const,
        ref,
        role: "button" as const,
        tabIndex: 0,
        onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            event.currentTarget.click();
          }
        },
      }
    : {
        component: "div" as const,
        ref,
      };

  if (mimicMantine) {
    return (
      <Flex
        align="center"
        pos="relative"
        w="100%"
        className={cx(S.TriggerContainer, {
          [S.hasValue]: hasValue,
        })}
        aria-label={ariaLabel}
        {...attributes}
      >
        {children}
      </Flex>
    );
  }

  return (
    <Box
      className={cx(S.parameter, className, {
        [S.selected]: hasValue,
      })}
      aria-label={ariaLabel}
      {...attributes}
    >
      {children}
    </Box>
  );
}
